import { Component, OnInit } from '@angular/core';
import { ApiRequestService } from '../../../_services/api-request.service';
import { MaterializeAction } from 'angular2-materialize';
import { Router } from "@angular/router";
import * as Chart from 'chart.js';
import 'chartjs-plugin-zoom';
import { SubscribeResultComponent } from '../subscribe-result/subscribe-result.component';

declare var $: any;
declare var Materialize:any;

@Component({
  selector: 'app-subscribe-analysis',
  templateUrl: './subscribe-analysis.component.html',
  styleUrls: ['./subscribe-analysis.component.css']
})
export class SubscribeAnalysisComponent implements OnInit {

  Result_data:any;
  Analysis_data:any;
  loading = 0;

  constructor(private apirequest: ApiRequestService, private router : Router) { }

  ngOnInit() {

    this.Result_data = JSON.parse(localStorage.getItem("Result_data"));
    console.log(this.Result_data);
    
    this.getAnalysis();
    $(document).ready(function() {
      $('.tooltipped').tooltip();
    });
  }

  msg_view(msg_data) {
    $(document).ready(function() {
      Materialize.toast(msg_data.toString(), 3000, 'grey darken-4');
    });
  }

  getAnalysis(){
    this.Analysis_data =  this.Result_data;
    setTimeout(() => {
      this.setCharts();          
     }, 1000);   
  }

  setCharts(){
    this.Donut_chart(this.Analysis_data.donut_data ,'Donut');
    this.mixchart('bar',this.Analysis_data.case_frequency ,'TimeChart'); 
    this.mixchart('bar',this.Analysis_data.overall_frequency ,'FrequencyChart');
    this.mixchart('line',this.Analysis_data.overall_frequency ,'RatioChart'); 
  }

  Donut_chart(data,id) {
    // this.data_type = DashoardComponent.data_type_info;
    // console.log(Object.keys(DashoardComponent.data_type_info));
    let col_name = Object.keys(data);
    console.log(col_name);

    
    var ch :any =  document.getElementById(id);
    var ctx:any = ch.getContext('2d');
    var myChart = new Chart(ctx, {
    type: 'doughnut',
    data: {
        labels: col_name,
        datasets: [{
        label: 'Storage',
        data: [data[col_name[0]],data[col_name[1]],data[col_name[2]]],
        backgroundColor: [
          'rgba(31,121,210,1)',
          'rgba(243,108,33,1)',
        ],
        borderColor: [
          'rgba(31,121,210,1)',
          'rgba(243,108,33,1)',
        ],
        borderWidth: 1
        }]
    },
    options: {
        cutoutPercentage: 40,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          titleFontSize: 20,
          bodyFontSize: 20
        },legend: {
          position: 'top',
          labels: {
            "fontSize": 16,
        }},
    }
    });
  }

  mixchart(chartname,data,id){
    var	myNewChartB;     
    let col_name = Object.keys(data);
    let global_label =  Object.keys(data[col_name[0]]);
    let dataset_1 = Object.values(data[col_name[0]]);
    let dataset_2 = Object.values(data[col_name[1]]);
    let dataset_3 = Object.values(data[col_name[2]]);
    console.log(dataset_1);
    
    console.log(col_name);
    var barData;
    barData = {
      labels: global_label,
      datasets: [{
        label: col_name[0],
        backgroundColor: "#1f79d2",
        borderColor: "#1f79d2",
        data: dataset_1,
        fill: false
      }, {
        label: col_name[1],
        backgroundColor: "#f36c21",
        borderColor: "#f36c21",
        data: dataset_2,
        fill: false
      }, {
        label: col_name[2],
        backgroundColor: "#3fae49",
        borderColor: "#3fae49",
        data: dataset_3,
        fill: false
      }]

    };
      console.log(barData);
      
      var ch :any =  document.getElementById(id);
      var ctx:any = ch.getContext('2d');
      myNewChartB = new Chart(ctx, {
          type: chartname,
          data: barData,
          options: {
            responsive: true,
            tooltips: {
              titleFontSize: 20,
              bodyFontSize: 20,
              yAlign: 'bottom',
            },
            maintainAspectRatio: false,
            legend: {
              position: 'top',
              labels: {
                "fontSize": 16,
            }},
            title: {
              display: false,
              text: 'Annual Invoice Amount',
              fontsize:20
            },
            pan: {
              enabled: true,
              mode: 'x',
              speed: 0.01,
              threshold: 10,            
              sensitivity: 0.01      
            },
            zoom: {
              enabled: true,         
              mode: 'x',
              speed: 0.01,
              sensitivity: 0.01 ,
              limits: {
                max: 10,
                min: 0.5
              } 
            }
          }
        });
  }
}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/subscribe-analysis/subscribe-analysis.component.ts